module.exports = __webpack_public_path__ + "static/media/mn4.9c015289.jpeg";